export default "__VITE_ASSET__B$B5PCVG__"